var _defs, _circle, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBalloonFullGray64X6421(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:none;stroke:#ccc;stroke-miterlimit:10;}.cls-3{fill:#bab8b6;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 32,
    cy: 24.11,
    r: 19.34
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32,2A22.09,22.09,0,0,1,53.66,19.37,22.5,22.5,0,0,1,52.5,32.52,78.51,78.51,0,0,1,40.68,53.35a56.26,56.26,0,0,1-8.3,8.46.51.51,0,0,1-.73.06l-.07-.06a50.56,50.56,0,0,1-7.21-7A71.78,71.78,0,0,1,11,31.12a22.09,22.09,0,0,1,13.9-28A22.5,22.5,0,0,1,32,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M53.08,19.52A21.57,21.57,0,0,0,32,2.38,21.11,21.11,0,0,0,21.65,5a21.83,21.83,0,0,0-10.11,26,71.38,71.38,0,0,0,13,23.43,51,51,0,0,0,7,7,.52.52,0,0,0,.74.05l.05-.05a55.41,55.41,0,0,0,8.14-8.35A78.5,78.5,0,0,0,51.93,32.56,22.63,22.63,0,0,0,53.08,19.52ZM31.92,42.21A18.11,18.11,0,1,1,49.94,24v.1A18.07,18.07,0,0,1,31.92,42.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M32.41,14.42c1.64,0,3.68-.11,5.7.05,2.22.18,4,1.54,4,3.07v7.11c0,.37-.15.46-.65.45h-4c-.45,0-.58-.1-.58-.41V19.51c0-.54-.28-.81-.86-.88-.78-.1-1.3.21-1.31.8v5.19c0,.4-.16.49-.72.48h-4c-.51,0-.66-.08-.66-.45V19.47c0-.53-.34-.82-1-.85s-1.17.24-1.17.77v5.18c0,.41-.14.55-.76.54h-4c-.39,0-.6,0-.6-.37V17.57c0-1.77,2.11-3.12,4.77-3.14C28.5,14.4,30.23,14.42,32.41,14.42Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M30.83,33.07a7.3,7.3,0,0,1-6.12-7.19v-.43H22.25a.43.43,0,0,0-.42.44h0c.43,7.6,5.73,10,8.5,10.76a3.86,3.86,0,0,0,.49.09Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.73,25.45H39.25v.43a7.28,7.28,0,0,1-6,7.17v3.68l.34-.07c2.76-.74,8.06-3.16,8.49-10.76A.41.41,0,0,0,41.73,25.45Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalloonFullGray64X6421);
export default __webpack_public_path__ + "static/media/balloon_full_gray_64x64-21.24e088284e69867a3b73d15e55effc2a.svg";
export { ForwardRef as ReactComponent };